"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _PopoverBoundary = _interopRequireDefault(require("../../Popover/PopoverBoundary"));

var _ModalContent = _interopRequireDefault(require("./ModalContent.style"));

const StyledModalContent = (0, _reactJss.default)(_ModalContent.default)((0, _react.memo)(({
  classes,
  id,
  visibility,
  children,
  enablePopoverBounding,
  className
}) => {
  const {
    boundaryRef
  } = (0, _react.useContext)(_PopoverBoundary.default.Context);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: enablePopoverBounding ? boundaryRef : null,
    id: id,
    className: (0, _clsx.default)(className, classes.contentWrapper, {
      disabled: visibility === 'disabled'
    }, {
      hidden: visibility === 'hidden'
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrap
  }, children));
}));

const ModalContent = props => /*#__PURE__*/_react.default.createElement(StyledModalContent, props);

ModalContent.defaultProps = {
  visibility: 'visible',
  enablePopoverBounding: true
};
var _default = ModalContent;
exports.default = _default;